/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './hospital-bill-discount.reducer';

export const HospitalBillDiscountDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const hospitalBillDiscountEntity = useAppSelector(state => state.hospitalBillDiscount.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="hospitalBillDiscountDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.hospitalBillDiscount.detail.title">HospitalBillDiscount</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.hospitalBillDiscount.id">Id</Translate>
            </span>
          </dt>
          <dd>{hospitalBillDiscountEntity.id}</dd>
          <dt>
            <span id="discountType">
              <Translate contentKey="tinyMedicRestApp.hospitalBillDiscount.discountType">Discount Type</Translate>
            </span>
          </dt>
          <dd>{hospitalBillDiscountEntity.discountType}</dd>
          <dt>
            <span id="billType">
              <Translate contentKey="tinyMedicRestApp.hospitalBillDiscount.billType">Bill Type</Translate>
            </span>
          </dt>
          <dd>{hospitalBillDiscountEntity.billType}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.hospitalBillDiscount.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{hospitalBillDiscountEntity.discount}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.hospitalBillDiscount.active">Active</Translate>
            </span>
          </dt>
          <dd>{hospitalBillDiscountEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.hospitalBillDiscount.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>
            {hospitalBillDiscountEntity.microSec ? (
              <TextFormat value={hospitalBillDiscountEntity.microSec} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.hospitalBillDiscount.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>
            {hospitalBillDiscountEntity.timestampEntry ? (
              <TextFormat value={hospitalBillDiscountEntity.timestampEntry} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.hospitalBillDiscount.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>
            {hospitalBillDiscountEntity.lastUpdated ? (
              <TextFormat value={hospitalBillDiscountEntity.lastUpdated} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.hospitalBillDiscount.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{hospitalBillDiscountEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalBillDiscount.bill">Bill</Translate>
          </dt>
          <dd>{hospitalBillDiscountEntity.bill ? hospitalBillDiscountEntity.bill.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/hospital-bill-discount" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/hospital-bill-discount/${hospitalBillDiscountEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HospitalBillDiscountDetail;
